// extracted by mini-css-extract-plugin
module.exports = {"root":"Questions_root__vS3nj"};